export enum MessageType {
    MESSAGE = 'MESSAGE',
    EVENT = 'EVENT',
    MESSAGEMETADATA = 'MESSAGEMETADATA',
}

export enum MessageParticipantRole {
    AGENT = 'AGENT',
    CUSTOMER = 'CUSTOMER',
    SYSTEM = 'SYSTEM',
    CUSTOM_BOT = 'CUSTOM_BOT',
    SUPERVISOR = 'SUPERVISOR',
}

export enum MessageVisibility {
    AGENT = 'AGENT',
    CUSTOMER = 'CUSTOMER',
    ALL = 'ALL',
}

export enum WebSocketTopic {
    AWS_SHERLOCK = 'aws/sherlock'
}
